import {
  MULTICALL_POLL_STATIC_MS,
  MULTICALL_POLL_VOLATILE_MS,
} from '../../constants/rpcPolling'
import type { AppState } from '../index'

export function blocksPerFetchKeyIsStatic(key: string): boolean {
  return key === 'Infinity' || key === 'null'
}

export function selectCallsFingerprint(state: AppState, chainId: number | undefined | null): string {
  if (chainId == null) return '[]'
  const listening = state.multicall.callListeners?.[chainId]
  if (!listening) return '[]'
  const callKeys = Object.keys(listening).filter((callKey) => {
    const byBlocks = listening[callKey]
    if (!byBlocks || typeof byBlocks !== 'object') return false
    return Object.values(byBlocks).some((count) => count > 0)
  })
  return JSON.stringify(callKeys.sort())
}

export function selectMulticallPollIntervalMs(
  state: AppState,
  chainId: number | undefined | null,
): number {
  if (chainId == null) return MULTICALL_POLL_VOLATILE_MS
  const listening = state.multicall.callListeners?.[chainId]
  if (!listening) return MULTICALL_POLL_VOLATILE_MS

  let hasVolatile = false
  let hasAny = false

  for (const callKey of Object.keys(listening)) {
    const byBlocks = listening[callKey]
    if (!byBlocks || typeof byBlocks !== 'object') continue
    for (const [blocksKey, count] of Object.entries(byBlocks)) {
      if (typeof count !== 'number' || count <= 0) continue
      hasAny = true
      if (!blocksPerFetchKeyIsStatic(blocksKey)) {
        hasVolatile = true
        break
      }
    }
    if (hasVolatile) break
  }

  if (!hasAny) return MULTICALL_POLL_VOLATILE_MS
  return hasVolatile ? MULTICALL_POLL_VOLATILE_MS : MULTICALL_POLL_STATIC_MS
}
